import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872";

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data("ek7000mb", function () {
    const el = $(this);

    return {
      localName: window.Shopify.locale,
      init() {
        /* 页面刷新时执行 */
        window.onload = function () {
          if (document.body.scrollTop > 0) {
            window.scrollTo(0, -1)
            document.body.scrollTop = 0
          }
          window.scrollTo(0, -1)
          document.body.scrollTop = 0
        }
        /* 页面刷新时执行 */
        $(function () {
          if (window.innerWidth < 1025) {
            /* 面包屑下拉列表 */
            let slide = true
            $('.list-down').click(function () {
              if (slide) {
                $('.choose-link-lists').slideDown(300)
                slide = false
                $(this).addClass('list-down-spec')
              } else {
                $('.choose-link-lists').slideUp(300)
                slide = true
                $(this).removeClass('list-down-spec')
              }
            })
            $(window).scroll(function (event) {
              if ($(window).scrollTop() > 0) {
                $(".product-details-top").addClass("product-details-special");
                $(".nav-container").hide();
                $(".nav").hide();
                $(".choose-link-lists").slideUp(300);
                slide = true;
                $(".list-down").removeClass("list-down-spec");
                $(".mobile-header").hide();
              } else {
                $(".product-details-top").removeClass("product-details-special");
                $(".mobile-header").show();
                $(".nav").show();
                $(".nav-container").show();
                $(".header-wrapper").show();
              }
            });
            $(".product-details-one").click(function () {
              $(".choose-link-lists").slideUp(300);
              slide = true;
              $(".list-down").removeClass("list-down-spec");
            });
            /* 面包屑下拉列表 */
            /* 点击事件 */
            let one = false
            let two = true
            let three = true
            let four = true
            $('.poster-ten-tab-top-one').click(function () {
              $('.poster-ten-show').hide()
              if (one) {
                $('.poster-ten-show-one').show()
                $('.poster-ten-tab-icon-one').addClass('poster-ten-tab-icon-spec')
                one = false
              } else {
                $('.poster-ten-show-one').hide()
                $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
                one = true
              }
              two = true
              three = true
              four = true
              $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
            })
            $('.poster-ten-tab-top-two').click(function () {
              $('.poster-ten-show').hide()
              if (two) {
                $('.poster-ten-show-two').show()
                $('.poster-ten-tab-icon-two').addClass('poster-ten-tab-icon-spec')
                two = false
              } else {
                $('.poster-ten-show-two').hide()
                $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
                two = true
              }
              one = true
              three = true
              four = true
              $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
            })
            $('.poster-ten-tab-top-three').click(function () {
              $('.poster-ten-show').hide()
              if (three) {
                $('.poster-ten-show-three').show()
                $('.poster-ten-tab-icon-three').addClass('poster-ten-tab-icon-spec')
                three = false
              } else {
                $('.poster-ten-show-three').hide()
                $('.poster-ten-tab-icon-three').removeClass(
                  'poster-ten-tab-icon-spec'
                )
                three = true
              }
              one = true
              two = true
              four = true
              $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
            })
            $('.poster-ten-tab-top-four').click(function () {
              $('.poster-ten-show').hide()
              if (four) {
                $('.poster-ten-show-four').show()
                $('.poster-ten-tab-icon-four').addClass('poster-ten-tab-icon-spec')
                four = false
              } else {
                $('.poster-ten-show-four').hide()
                $('.poster-ten-tab-icon-four').removeClass('poster-ten-tab-icon-spec')
                four = true
              }
              one = true
              two = true
              three = true
              $('.poster-ten-tab-icon-one').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-two').removeClass('poster-ten-tab-icon-spec')
              $('.poster-ten-tab-icon-three').removeClass('poster-ten-tab-icon-spec')
            })
            /* 点击事件 */
            /* 下滑文字效果 */
            $(window).scroll(function (event) {
              const wst = $(window).scrollTop()
              const st = wst + 56
              // const wh = $(window).height()
              /* section two */
      
              const xf = $('.poster-two-mb').offset().top
              const xf1 = xf + 100
              const xf2 = xf + 200
              const xf3 = xf + 300
              const xf4 = xf + 400
              const xf5 = xf + 500
              const xf6 = xf + 600
              const xf7 = xf + 700
              const xf8 = xf + 800
              const xf9 = xf + 900
              const xf10 = xf + 1000
              const xf11 = xf + 1100
              const xf12 = xf + 1200
              const xf13 = xf + 1300
              const xf14 = xf + 1400
              console.log(888)
              console.log(st)
              console.log(xf)
              console.log(xf1)
              if (st < xf) {
                console.log(12)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img1').show()
              } else if (st > xf && st < xf1) {
                console.log(23)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img2').show()
              } else if (st > xf1 && st < xf2) {
                console.log(34)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img3').show()
              } else if (st > xf2 && st < xf3) {
                console.log(45)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img4').show()
              } else if (st > xf3 && st < xf4) {
                console.log(56)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img5').show()
              } else if (st > xf4 && st < xf5) {
                console.log(67)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img6').show()
              } else if (st > xf5 && st < xf6) {
                console.log(78)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img7').show()
              } else if (st > xf6 && st < xf7) {
                console.log(90)
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img8').show()
              } else if (st > xf7 && st < xf8) {
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img9').show()
              } else if (st > xf8 && st < xf9) {
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img10').show()
              } else if (st > xf9 && st < xf10) {
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-images').show()
                $('.ek7000-camera-img').hide()
                $('.ek7000-camera-img11').show()
              } else if (st > xf10 && st < xf11) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item1').show()
              } else if (st > xf11 && st < xf12) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item2').show()
              } else if (st > xf12 && st < xf13) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item3').show()
              } else if (st > xf13 && st < xf14) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-color').hide()
                $('.ek7000-camera-other').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item4').show()
              } else if (st > xf14) {
                $('.ek7000-camera-images').hide()
                $('.ek7000-camera-other').hide()
                $('.ek7000-camera-color').show()
                $('.ek7000-camera-other-item').hide()
                $('.ek7000-camera-other-item5').show()
              }
      
              /* section two */
      
              /* section eight */
      
              const targetElement = $('.poster-seven-mb').offset().top
              console.log(1819)
              console.log(targetElement)
              if (st > targetElement) {
                const widthNew = st - targetElement - 600
                const width = widthNew / 4
                // const wipeNew = width / 146
                // const wipeNews = 100 - wipeNew * 100
                // const wipe = wipeNews + '%'
                console.log(999)
                console.log(width)
                if (width <= 84) {
                  $('.total-runtime-img').css('width', width)
                  // $('.total-runtime-title').css('--wipe', wipe)
                } else {
                  $('.total-runtime-img').css('width', '84px')
                  // $('.total-runtime-title').css('--wipe', '0%')
                }
              }
      
              /* section eight */
      
              /* section nine */
      
              const nx = $('.poster-nine-mb').offset().top
              const mx = nx
              const qx = mx + 480
              const wx = mx + 960
              const ex = mx + 1440
              if (st < qx) {
                console.log(1111)
                $('.poster-nine-imgs-one').hide()
                $('.poster-nine-imgs-two').hide()
                $('.poster-nine-imgs-one1').show()
                setTimeout(function () {
                  $('.poster-nine-imgs-one-box1').addClass('container-add-spec')
                }, 50)
              } else if (st > qx && st < wx) {
                console.log(3333)
                $('.poster-nine-imgs-one').hide()
                $('.poster-nine-imgs-two').hide()
                $('.poster-nine-imgs-two1').show()
                setTimeout(function () {
                  $('.poster-nine-imgs-two-box1').addClass('container-add-spec')
                }, 50)
              } else if (st > wx && st < ex) {
                console.log(4444)
                $('.poster-nine-imgs-one').hide()
                $('.poster-nine-imgs-two').hide()
                $('.poster-nine-imgs-two2').show()
                setTimeout(function () {
                  $('.poster-nine-imgs-two-box2').addClass('container-add-spec')
                }, 50)
              } else if (st > ex) {
                console.log(5555)
                $('.poster-nine-imgs-one').hide()
                $('.poster-nine-imgs-two').hide()
                $('.poster-nine-imgs-two3').show()
                setTimeout(function () {
                  $('.poster-nine-imgs-two-box3').addClass('container-add-spec')
                }, 50)
              }
      
              /* section nine */
            })
          }
        })
      },
    };
  });
}

document.addEventListener("alpine:init", main);